export default __webpack_public_path__ + "static/new-italia-3-101d636369fc88c564102674ab37247d.jpg";